import DashboardService from 'services/DashboardService';

export const getGrantingAdminsForDashboardQuery = (id) => {
  return DashboardService.getGrantingAdmins(id);
};
